module.exports = __webpack_public_path__ + "img/xmark-to-slot.6afa6c9d.svg";